import { cms_logging } from './cms_logging'

export class Point {
    public X: number;
    public Y: number;

    public static NULL: Point = new Point(5000, 5000);

    public static build_from_array(coord: number[]): Point {
        return Point.build(coord[0], coord[1]);
    }
    public static build(x: number, y: number): Point {
        if (typeof (x) === typeof (1)) {
            if (typeof (y) === typeof (1)) {
                return new Point(x, y);
            }
        }
        return null;
    }
    private constructor(x: number, y: number) {
        this.X = x;
        this.Y = y;
    }
    public toString(): string {

        return JSON.stringify(this.toArray());
    }
    public toArray(): number[] {
        return [this.X, this.Y];
    }
    public toJSON() {
        return this.toArray();
    }

}




// WEBPACK FOOTER //
// ./src/ts/Point.ts